import React, { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";

export const QuestionnaireMultiSelectPage = ({
	def,
	onRespond,
	currentResponse,
}) => {
	const [selectedOption, setSelectedOption] = useState([]);
	const [defaultOption, setDefaultOption] = useState([]);

	useEffect(() => {
		const opts = [];

		if (def.options) {
			for (const o of def.options) {
				if (o.default) {
					opts.push(o.value);
				}
			}
		}

		setDefaultOption(opts);

		if (!currentResponse) {
			const response = {};
			response.id = def.id;
			response.value = opts;

			onRespond(response);
		}
	}, [def]);

	useEffect(() => {
		let opt;

		if (
			currentResponse &&
			currentResponse.value &&
			currentResponse.value.length
		) {
			opt = currentResponse.value;
		} else if (def.answer && def.answer.length) {
			opt = def.answer;

			const response = {};
			response.id = def.id;
			response.value = opt;

			onRespond(response);
		} else {
			opt = defaultOption || [];
		}

		setSelectedOption(opt);
	}, [currentResponse, def, defaultOption]);

	const handleChange = (e) => {
		const value = e.target.value;
		const checked = e.target.checked;
		let sel = [...selectedOption];

		// find the corresponding entry in the options
		const findOption = (value) => {
			return def.options.find((o) => o.value.toString() === value.toString());
		};

		if (checked) {
			const opt = findOption(value);

			if (!opt) {
				return;
			}

			if (opt.clearOthers) {
				sel = [value];
			} else {
				for (let i = sel.length - 1; i >= 0; i--) {
					const selOpt = findOption(sel[i]);
					if (selOpt.clearOthers) {
						sel.splice(i, 1);
					}
				}

				sel.push(value);
			}
		} else {
			const index = sel.indexOf(value);
			if (index >= 0) {
				sel.splice(index, 1);
			}
		}

		if (sel.length === 0) {
			sel = defaultOption;
		}

		const response = {};
		response.id = def.id;
		response.value = sel;

		onRespond(response);
	};

	const renderOptions = (s) => {
		return def.options
			? def.options.map((option, i) => (
					<div key={`${i}_container`} className={option.hidden ? "hidden" : ""}>
						<label
							key={`${i}_label`}
							className={`${
								s.indexOf(option.value.toString()) >= 0
									? "bg-black text-white font-medium"
									: "bg-gray-100 text-black"
							} text-right text-base sm:text-lg leading-5 sm:leading-6 font-normal rounded-full mx-3 option pr-2 pl-7 py-2.5 cursor-pointer flex items-center justify-end my-3 lg:my-4`}
						>
							{option.label}
							<span
								className={`flex flex-0-0-auto justify-center items-center w-4 h-4 text-white border border-gray-400 rounded mx-2.5`}
							>
								{s.indexOf(option.value.toString()) >= 0 && (
									<FaCheck size={8} />
								)}
							</span>
							<input
								key={`${i}_input`}
								name={def.title}
								value={option.value.toString()}
								className={"hidden "}
								type="checkbox"
								checked={s.indexOf(option.value.toString()) >= 0 ? true : false}
								onChange={handleChange}
							/>
						</label>
					</div>
			  ))
			: null;
	};

	return (
		<>
			<QuestionnaireHeader def={def} />

			<div>{renderOptions(selectedOption)}</div>

			<QuestionnaireFooter def={def} />
		</>
	);
};
